var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTopical = function SvgTopical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#topical_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    strokeMiterlimit: 10,
    d: "M38.917 19.784h-.808c-.968 0-1.614-.646-1.614-1.615v-3.875h-20.99v4.037c0 .969-.646 1.614-1.614 1.614h-.808a3.24 3.24 0 0 0-3.229 3.23v17.76a3.24 3.24 0 0 0 3.23 3.23h25.833a3.24 3.24 0 0 0 3.229-3.23v-17.76c0-1.938-1.453-3.391-3.23-3.391Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    strokeMiterlimit: 10,
    d: "M38.917 12.68c0 .968-.646 1.614-1.615 1.614H14.698c-.969 0-1.615-.646-1.615-1.614v-1.615a3.24 3.24 0 0 1 3.23-3.23h19.374a3.24 3.24 0 0 1 3.23 3.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.954 32.381c-1.05 1.24-5.1 2.152-5.635 1.264a6.04 6.04 0 0 1 1.873-2.833C19.258 29.24 19.03 27.843 19 27.295a6.26 6.26 0 0 1 4.959.602A6.15 6.15 0 0 1 25.999 23a6.15 6.15 0 0 1 2.042 4.897A6.26 6.26 0 0 1 33 27.295c-.03.552-.258 1.945-3.193 3.517a6.04 6.04 0 0 1 1.873 2.833c-.535.888-4.672-.025-5.721-1.264M26 32v5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "topical_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h52v52H0z"
  })))));
};
export default SvgTopical;